import React, { useRef, useEffect } from "react";
import MainImage5 from "../../assets/AboutImage6-1.jpg"; // Using MainImage5 for hero section
import MainImage6 from "../../assets/AboutImage7.jpg";
import Footer from "../../components/Footer";
import About from "../../components/About";
import Testimony from "../../components/Testimony";
import NavLite from "../../components/NavLite";

// Importing images from the assets folder
import TestimonyImage1 from "../../assets/VisibilityAudit/VisibilityAudit2.png";
import TestimonyImage2 from "../../assets/VisibilityAudit/VisibilityAudit7.png";
// import TestimonyImage3 from '../../assets/VisibilityAudit/VisibilityAudit3.png';
import TestimonyImage4 from "../../assets/VisibilityAudit/VisibilityAudit4.png";
import TestimonyImage5 from "../../assets/VisibilityAudit/VisibilityAudit5.png";
import TestimonyImage6 from "../../assets/VisibilityAudit/VisibilityAudit6.png";
import TestimonyImage7 from "../../assets/VisibilityAudit/VisibilityAudit11.png";
import TestimonyImage8 from "../../assets/VisibilityAudit/VisibilityAudit8.png";
import TestimonyImage9 from "../../assets/VisibilityAudit/VisibilityAudit9.png";
import TestimonyImage10 from "../../assets/VisibilityAudit/VisibilityAudit10.png";
import TestimonyImage11 from "../../assets/VisibilityAudit/VisibilityAudit.png";

function FreeReviewLanding() {
  <main>
  <title>Free Website Visibility Review | Boost Your Online Presence | Her Growth Co.</title>
<meta
name="description"
content="Discover how your current site ranks. Get a free visibility review and see where you can improve SEO, design, and traffic strategy."
/>
<meta
name="keywords"
content="free website audit for women-owned brands, visibility review for female-led businesses, complimentary brand checkup, expert feedback for online growth, start your visibility journey, web strategy intro for founders, free growth insight for consultants, web design austin tx, seo services austin, premium website design austin, austin seo expert, custom web design for consultants austin, austin seo for creatives, authority website design austin, high-end seo agency austin, austin local seo services, web design for coaches austin, conversion-focused web design austin, bespoke websites austin, seo for service providers austin, austin high-ticket web design, expert seo strategy austin, website design agency austin, austin tx web design for women, seo for women-led businesses austin, women entrepreneur seo austin, austin website agency for female founders, mobile-first web design austin, seo content strategy austin, interactive website design austin tx, austin digital marketing agency, high-converting websites austin, seo consultant for women austin, austin brand visibility seo"
/>
</main>
  useEffect(() => {
    const script = document.createElement("script");
    script.src = "https://app.mailjet.com/pas-nc-embedded-v1.js";
    script.type = "text/javascript";
    script.async = true;
    document.body.appendChild(script);
  }, []);

    const containerRef = useRef(null);

  const handleScrollLeft = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: -1040, behavior: "smooth" }); // Scroll by the width of 4 items (250px each)
    }
  };

  const handleScrollRight = () => {
    if (containerRef.current) {
      containerRef.current.scrollBy({ left: 1040, behavior: "smooth" }); // Scroll by the width of 4 items (250px each)
    }
  };

  // Array of testimonials with image sources
  const testimonials = [
    { image: TestimonyImage1, name: "David James", role: "CEO/Chairman" },
    { image: TestimonyImage2, name: "Sarah Lee", role: "Founder" },
    // { image: TestimonyImage3, name: "James Smith", role: "Marketing Director" },
    { image: TestimonyImage4, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage5, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage6, name: "Linda Green", role: "COO" },
    { image: TestimonyImage7, name: "Emily White", role: "Product Manager" },
    { image: TestimonyImage8, name: "Michael Brown", role: "CTO" },
    { image: TestimonyImage9, name: "Linda Green", role: "COO" },
    { image: TestimonyImage10, name: "Linda Green", role: "COO" },
    { image: TestimonyImage11, name: "Linda Green", role: "COO" },
  ];


  return (
    <main className="relative min-h-screen w-screen overflow-x-hidden bg-[#F4F3E1]">
      <title>Free Website Speed & SEO Review | Get Your Personalized Loom Video | Her Growth Co</title>
      <meta
        name="description"
        content="Get a free personalized Loom video review of your website's speed and SEO. Discover hidden issues and actionable insights to attract more clients."
      />
      <meta
        name="keywords"
        content="website designer near me, website design near me, web designers near me, website designers, website builders near me, website designers near me, local website designers, web designer near me, web design company near me, web designing near me, professional website designer, local web designers, local web designer, local website designers near me"
      />

      <section>
        <div
          className="relative bg-cover bg-center h-auto"
          style={{ backgroundImage: `url(${MainImage5})` }}
        >
          <NavLite/>

          <div className="flex flex-col max-w-2xl py-12 md:py-16 lg:py-10 gap-10 ml-10 ">
            <div className="flex flex-col items-start gap-y-5 bg-black/1 backdrop-blur-sm">
              <h1 className="text-left text-3xl font-bold md:text-5xl text-white uppercase ">
                Unlock Your Website's Potential - <span className=" bg-[#CFF098] text-black italic">For Free</span>!
              </h1>
              <p className="text-left text-white bg-black/1 backdrop-blur-sm max-w-2xl text-xl font-bold italic">
                Discover the key areas holding you back with our FREE,
                personalized Loom video review. We'll show you exactly how to
                boost your website's speed and SEO.
              </p>
            </div>
            <div className="flex flex-col gap-4 font-regular sm:flex-row">
              <a
                href="/contact" // Replace with your form page URL
                className="flex rounded-full items-center gap-4 bg-[#CFF098] px-6 py-3 text-black border-[1px] border-black shadow-md"
              >
                <p>Get Your Free Website Review</p>
              </a>
            </div>
          </div>
        </div>

        <section className="bg-[#F7F3F2]">
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-20">
            <div className="flex flex-col items-center text-center">
              <div className="flex items-center rounded-md px-3 py-1">
                <p className="text-sm uppercase mb-12 text-black">
                  Free Website Review
                </p>
              </div>
              <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl">
              <span className=" bg-[#CFF098] text-black italic"> Get Actionable Insights</span> to Boost Your Online Presence
              </h2>
              <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light">
                We'll analyze your website's speed, SEO, and user experience,
                providing you with a personalized Loom video review and
                actionable recommendations.
              </p>
            </div>

            <div className="grid gap-5 sm:grid-cols-1 md:grid-cols-3 md:gap-4 mb-10">
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Personalized Loom Video Walkthrough
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Get a clear, actionable video review of your website,
                  tailored to your specific needs. We'll highlight critical
                  issues and provide quick-fix suggestions.
                </p>
              </div>

              <div className="grid gap-6 border border-solid border-black p-8 md:p-10 ">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Website Speed & Performance Analysis
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  Discover how fast (or slow!) your website loads. We'll show you
                  the impact of speed on user experience and SEO, and offer
                  practical solutions.
                </p>
              </div>
              <div className="grid gap-6 border border-solid border-black p-8 md:p-10">
                <h3 className="text-xl font-semibold text-black uppercase">
                  Essential SEO Review
                </h3>
                <p className="text-black text-lg mb-10 font-light">
                  We'll examine your website's key SEO elements (title tags,
                  meta descriptions, header tags) and identify opportunities for
                  improvement. Get ready to rank higher!
                </p>
              </div>
            </div>

            <div className="flex flex-col items-center justify-center mt-10">
              <a
                href="/contact" // Replace with your form page URL
                className="text-black bg-[#CFF098] rounded-full px-8 py-3 border-[1px] border-black mt-8 text-xl font-semibold hover:bg-[#b0e07f] transition-colors duration-300"
              >
                GET YOUR FREE WEBSITE REVIEW →
              </a>
              <p className="text-black text-lg font-light mt-6">
                Limited spots available!
              </p>
            </div>
          </div>
{/* Video Component Added Here */}
<div className="flex flex-col items-center justify-center">
  <h2 className="text-3xl font-regular md:text-5xl text-black max-w-2xl text-center mb-4">
    Why <span className=" bg-[#CFF098] text-black italic">Choose Us</span>
  </h2>

  <p className="mb-8 mt-4 max-w-lg text-base text-black md:mb-12 md:text-lg font-light text-center">
  We're a web design agency dedicated to helping women-owned businesses rank #1 on Google.
              </p>
</div>

        </section>

        <section>
          <div className="mx-auto w-full max-w-7xl px-5 py-16 md:px-10 md:py-10 ">
            <div className="mb-4 grid grid-cols-1 md:grid-cols-2 gap-8 items-start">
              <h2 className="text-3xl font-semibold max-w-lg mt-8 sm:mt-18">
                <span className="bg-[#CFF098] text-black italic">
                  More Packages
                </span>{" "}
                We Offer.
              </h2>
              <div className="space-y-4 ">
              <h4 className="font-semibold">Visibility Audit Package ($99):</h4>
                <p className="text-sm text-gray-300 max-w-lg">
                  You will get a concise report and personalized Loom walkthrough, analyzing website speed, mobile responsiveness, on-page and local SEO, and UX, providing actionable recommendations for improved online performance.
                </p>
                <a href="/visibilityaudit">
                <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black mt-2 mb-4">
                View Visibility Audit Package →
                </button>
                </a>
                <h4 className="font-semibold">
                  Elite & Visible Package ($3999):
                </h4>
                <p className="text-sm text-gray-300 max-w-lg">
                  We provide a custom website, comprehensive SEO, and strategic
                  content to establish your authority and drive business growth.
                </p>
                <a href="/elitevisible">
                  <button className="text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black mt-2">
                    View Elite & Visible Package →
                  </button>
                </a>
              </div>
            </div>
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4"></div>
          </div>
        </section>

        <section
          className="bg-cover bg-center"
          style={{ backgroundImage: `url(${MainImage6})` }}
        >
          <div className="">
            <div className="mx-auto w-full text-center bg-[#000000] bg-opacity-60 p-6">
              <h2 className="mx-auto mb-2 max-w-3xl flex-col text-3xl font-bold md:mb-6 md:text-4xl lg:mb-6  text-white ">
                Ready to See Your Website's Potential?
              </h2>
              <p className="mx-auto mb-2 max-w-xl text-sm text-gray-300 sm:text-base md:mb-4">
                Get your free website review today and discover how we can help
                you attract more clients.
              </p>
              <a
                href="/contact" // Replace with your consultation booking URL
                className="mb-4 inline-block text-black bg-[#CFF098] rounded-full px-6 py-2 border-[1px] border-black"
              >
                Get Your Free Website Review
              </a>
            </div>
          </div>
        </section>

        {/* Our Projects */}

        <section className="">
          <div className="bg-[#F7F3F2] h-auto">
            <h2 className="text-center text-2xl font-bold md:text-3xl text-black pt-16 mb-16 uppercase">
              Our{" "}
              <span className="bg-[#CFF098] text-black italic">
                Happy Clients
              </span>{" "}
            </h2>

            {/* Left Arrow Button */}
            <button
              className="absolute top-1/2 left-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollLeft}
            >
              {/* Left Arrow SVG */}
              {/* <svg
                width="50"
                height="50"
                viewBox="0 0 72 73"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect
                  x="0.5"
                  y="1"
                  width="71"
                  height="71"
                  rx="35.5"
                  stroke="#000000" // White color for the background circle stroke
                />
                <path
                  d="M44 35.5H31.83L37.42 29.91L36 28.5L28 36.5L36 44.5L37.41 43.09L31.83 37.5H44V35.5Z"
                  fill="#000000" // White color for the arrow itself
                />
              </svg> */}
            </button>

            <div className="relative flex items-center justify-center">
              <div
                ref={containerRef}
                className="flex overflow-x-auto gap-28 py-6 scroll-smooth scroll-m-0  max-w-[1040px] w-full" // Limit the width to 4 items
              >
                {testimonials.map((testimonial, index) => (
                  <div key={index} className="min-w-[650px]">
                    <img
                      className="object-cover w-full h-auto"
                      src={testimonial.image} // Display the image from assets
                      alt={`Testimonial ${index + 1}`}
                    />
                  </div>
                ))}
              </div>
            </div>

            {/* Right Arrow Button */}
            <button
              className="absolute top-1/2 right-0 transform -translate-y-1/2 z-10 p-6 pt-28"
              onClick={handleScrollRight}
            >
              {/* Right Arrow SVG */}
              {/* <svg
              width="50"
              height="50"
              viewBox="0 0 72 73"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect
                x="0.5"
                y="1"
                width="71"
                height="71"
                rx="35.5"
                stroke="#000000" // White color for the background circle stroke
              />
              <path
                d="M36 28.5L34.59 29.91L40.17 35.5H28V37.5H40.17L34.59 43.09L36 44.5L44 36.5L36 28.5Z"
                fill="#000000" // White color for the arrow itself
              />
            </svg> */}
            </button>
          </div>
        </section>


        <Testimony/>
        <section className="bg-white px-4 py-8 h-auto md:h-[850px] flex justify-center items-center">
  <div className="max-w-3xl mx-auto w-full md:w-max-[650px] flex flex-col items-center">
    <h1 className="mb-3 text-2xl md:text-3xl font-semibold text-black text-center uppercase">
      Stop Guessing, <span className="italic text-black bg-[#CFF098]"> Start Growing!</span> Get Your FREE Website Visibility Audit Now.
    </h1>
    <p className="text-center text-black text-sm mb-6">Uncover the secrets holding your website back from ranking #1 and attracting a flood of new clients. Get your FREE personalized Loom video audit today!</p>
    <div className="w-full max-w-md md:w-[550px] text-black">
      <div className="relative" style={{ paddingBottom: "160%", height: 0 }}> {/* Adjusted padding for mobile */}
        <iframe
          data-w-type="embedded"
          src="https://sngg6.mjt.lu/wgt/sngg6/x845/form?c=36514eab"
          className="absolute top-0 left-0 w-full h-full"
          style={{ border: "none" }}
          scrolling="no"
          title="Mailjet Embedded Form"
        />
      </div>
    </div>
  </div>
</section>

        <About />

        <Footer />
      </section>
    </main>
  );
}

export default FreeReviewLanding;